module.exports = __webpack_public_path__ + "img/banner_left.e72596ba.jpg";